module.exports = __webpack_public_path__ + "assets/img/首页小图-烟感.9f0582c8.jpg";